import React from "react";
import { Outlet, useLocation } from "react-router-dom";
import SidebarComponent from "./components/SidebarComponent";
import { useSelector } from "react-redux";
import { selectLoaderValue } from "../../redux/Slices/loadingSlice";
import ProfileSidebarComponent from "./components/ProfileSidebarComponent";
import MyProfileSidebarComponent from "./components/MyProfileSidebarComponent";
import SharedHeader4 from "../../Headers/SharedHeader4";
import Spinner from "../shared/components/Spinner";

const ProfessionalLayout = () => {
    const isLoading = useSelector(selectLoaderValue);
    const location = useLocation();
    const getSideBarComponent = () => {
        if (location.pathname === "/professionals/settings") {
            return (
                <></>
            );
        }
        else if (location.pathname === "/professionals/myprofile") {
            return (<MyProfileSidebarComponent />);
        }
        return (<SidebarComponent />);
    };
    return (
        <Outlet />
        // <div className="min-h-screen bg-gray-50">
        //     {/* Header */}
        //     <SharedHeader4 />
        //     {isLoading && (
        //         <div className="fixed left-[50%] top-[50%] z-[1000px]">
        //             <Spinner color="green" />
        //         </div>
        //     )}
        //     <div className={`flex min-h-screen ${isLoading ? "opacity-25" : "opacity-100"}`}>
        //         {getSideBarComponent()}
        //         <div className={`flex-1 w-full ${location.pathname === "/professionals/myprofile" ||  location.pathname === "/professionals/settings" ? "" : "lg:pl-64"}`}>
        //             <main className={`flex-1 ${location.pathname === "/professionals/myprofile" ? "lg:pl-64 px-6 py-8 max-w-6xl mx-auto" : "p-4 lg:p-8"}`}>
        //                 <Outlet />
        //             </main>
        //         </div>

        //     </div>
        // </div>
    );
};

export default ProfessionalLayout;